export const APPLICATION_FLOW = {
  DEFAULT: 'DEFAULT',
  BROKER: 'BROKER',
  OCM: 'OCM',
  UPGRADE: 'UPGRADE',
};
